import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionLongevity from "../../Sections/SectionLifestyle/SectionLongevity";


import { useTheme } from "@mui/material";

export default function LongevityWelcome() {

    const theme = useTheme();

return (
<>
    


    <PageProtected
    
    headline="AGING - " 
    specify ="LONGEVITY GENETICS"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C500"
            Section_1={ <SectionLongevity /> }

            colorSection_2="grey.C300"
            Section_2={"" }
            
            colorSection_3="grey.C100"
            Section_3= {"" } 

            colorSection_4="primary.C200"
            Section_4={""}

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="secondarydark.C200"
            Section_1={ <SectionLongevity /> }

            colorSection_2="secondarydark.C100"
            Section_2={ ""}
            
            colorSection_3="secondarydark.C100"
            Section_3= { ""} 

            colorSection_4="secondarydark.C200"
            Section_4={""}
        />
        )}
    </>
    }
/>

</>
)
}